import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Input, Typography } from 'antd';
import { useValidateInfo } from 'all-in-one-shared-api';
// import { InfoCircleOutlined } from '@ant-design/icons';
import { useContext } from 'react';
// import { VStack } from "components";
import generateKey from 'utils/generateKey';
import { ActionType, RegistrationFlowContext, RegistrationFormData } from 'contexts/registration';
import { ForgotPasswordData } from './forgotPasswordData';
import PolicyAndMemberIdModal from './PolicyAndMemberIdModal';
// import { Wrapper } from './styledComponents';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
import { setErrorCodeFun } from 'utils/setErrorCodeFun/setErrorCodeFun';
import { useMediaQuery } from 'react-responsive';
import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
function ForgotPasswordWithEmailPage() {
  const initialValues = useRegistrationStateQuery();
  console.log('initialvalues-----------------', initialValues);
  const isLargeScreen = useMediaQuery({ minWidth: 768 });
  const { state, dispatch } = useContext(RegistrationFlowContext);
  const { t, i18n } = useTranslation();
  const [formDataState, setFormDataState] = React.useState<ForgotPasswordData>({
    email: '',
  });
  const navigate = useNavigate();
  const [forgotPasswordWithLoginKey, setForgotPasswordWithLoginKey] = React.useState<string>('');
  // const [method, setMethod] = React.useState('loginId');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [form] = Form.useForm();
  const [errmessage, setErrmessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState<string | null>(null);

  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);

  // const onChange = (e: RadioChangeEvent) => {
  //   setMethod(e.target.value);
  // };
  useEffect(() => {
    console.log('state  emailpage', state);
  }, [state]);
  const {
    shouldFetch: shouldValidateFetch,
    data: forgotPasswordWithLoginData,
    error: validateError,
  } = useValidateInfo(
    forgotPasswordWithLoginKey,
    initialValues.selfDefinedLoginId || '',
    formDataState.email,
    '',
    '',
    'Y',
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      onSuccess: () => {
        setIsLoading(false);
        // setStartLoading(false);
      },
      onError: () => {
        setIsLoading(false);
        // setStartLoading(false);
        // const message = setErrorCodeFun(err.code, i18n.language);
      },
    },
  );

  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  const closeModel = () => {
    setIsModalVisible(false);
  };
  console.log('state', state);
  useEffect(() => {
    if (forgotPasswordWithLoginData && !validateError) {
      dispatch({
        type: ActionType.UpdateFormData,
        payload: { email: formDataState.email },
      });
      console.log('-----------before navigate initialValues', state, initialValues);
      navigate('/forgot/otp-verification', {
        replace: true,
        state: {
          loginId: initialValues.selfDefinedLoginId || '',
          mobile: initialValues.mobile || '',
          email: initialValues.email || '',
          countryCode: initialValues.countryCode || '',
          prevPath: location.pathname ?? '',
        },
      });
    }
  }, [forgotPasswordWithLoginData, validateError, navigate, state, initialValues, dispatch, formDataState]);
  useEffect(() => {
    if (validateError?.code) {
      shouldValidateFetch(false);
      setIsLoading(false);
      setErrors(validateError.code);
      //   setLoading(false);
      let errorMessage = setErrorCodeFun(validateError.code, i18n.language);
      console.log('error', validateError);
      if (validateError.code == 'auth.recovery.invalid.email') errorMessage = t('registration.error.invalidEmail');
      setErrmessage(errorMessage ?? validateError.code ?? validateError.message);
    }
    if (i18n.language && errors) {
      const message = setErrorCodeFun(errors, i18n.language);
      if (errors == 'auth.recovery.invalid.email') setErrmessage(t('registration.error.invalidEmail'));
      else setErrmessage(message ?? errors);
    }
  }, [validateError, shouldValidateFetch, i18n.language, errors, t]);

  // const handleCloseSnackbar = () => {
  //   setShowError(false);
  // };

  const onValidateSuccessful = React.useCallback(
    (data: RegistrationFormData, event?: React.BaseSyntheticEvent) => {
      event && event.preventDefault();
      dispatch({ type: ActionType.UpdateFormData, payload: { email: formDataState.email } });
      setForgotPasswordWithLoginKey(generateKey);
      shouldValidateFetch(true);
      setIsLoading(true);
    },
    [dispatch, shouldValidateFetch, formDataState],
  );

  // Note(Anson Kan): I don't know how to type return values from `antd` `Form`...
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onFinish = () => {
    // navigate("/forget/otp-verification", {
    //   state: {
    //     loginId: state.selfDefinedLoginId,
    //     mobile: state.mobile ?? "",
    //     countryCode: state.countryCode ?? "",
    //     prevPath: location.pathname,
    //   },
    // }); //提交时注释掉
    //setFormDataState({
    //email: values.email,
    // selfDefinedLoginId: values.selfDefinedLoginId,
    // memberId: values.memberId && values.memberId.toString(),
    // policyNumber: values.memberId && values.policyNumber.toString(),
    //});
    onValidateSuccessful(formDataState);
  };
  const isValid = formDataState.email?.trim() !== '';

  // useEffect(() => {
  //   if (formDataState.email) {
  //     // 确保formDataState更新后才执行
  //     // onValidateSuccessful(formDataState);
  //   }
  // }, [formDataState, onValidateSuccessful]);
  // const infoIcon = <InfoCircleOutlined onClick={showModal} style={{ cursor: 'pointer' }} />;

  return (
    <div
      className="forgot_wrapper"
      style={{
        paddingLeft: isLargeScreen ? '40px' : '0',
        paddingRight: isLargeScreen ? '40px' : '0',
      }}
    >
      {/* <img src={forgotIcon} alt="forgot-icon" style={{ marginBottom: 12 }} /> */}
      <Typography.Title
        level={3}
        style={{ fontSize: '33px', fontFamily: 'Roboto400', color: '#fff', fontWeight: '400' }}
      >
        {t('life.forgetLoginId.ForgotPassword')}{' '}
      </Typography.Title>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          paddingBottom: '200px',
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '0',
            border: '0',
            width: isLargeScreen ? '50%' : '100%', // 根据屏幕大小动态调整宽度
            padding: '20px',
          }}
        >
          {/* <VStack>
          
          <Space style={{ marginTop: 16, marginBottom: 16 }}>
            <Typography.Text>{t("forgetPassword.instruction")}</Typography.Text>
          </Space>
        </VStack> */}
          <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}>
            {t('forgetPassword.emailDescription')}
          </Typography.Text>
          <Form
            layout={'vertical'}
            form={form}
            style={{ marginTop: 16 }}
            onFinish={onFinish}
            // requiredMark="optional"
            validateTrigger={false}
            onChange={() => {
              // 获取当前所有字段的值
              const formValues = form.getFieldsValue();

              // 如果 selfDefinedLoginId 有变化，则更新 formDataState
              if (formValues.email !== undefined) {
                setFormDataState({ email: formValues.email });
              }
              setErrmessage('');
            }}
          >
            <Form.Item
              label={
                <span style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}>
                  {t('forgetPassword.emailLabel')}
                </span>
              }
              name="email"
              style={{ marginBottom: 12 }}
              rules={[
                // { required: true, message: t('registration.error.required') },
                {
                  validator: (_, value) => {
                    const emailRegex = new RegExp(
                      '^(?=.{1,50}$)[a-zA-Z0-9_!#$%&*+/=?`{|}~^.-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9-]+)*\\.[A-Za-z]{2,}$',
                    );

                    if (!value) {
                      return Promise.reject(new Error(t('registration.error.required')));
                    }

                    if (!emailRegex.test(value)) {
                      return Promise.reject(new Error(t('registration.error.invalidEmail')));
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                size="middle"
                placeholder={t('forgetPassword.emailPlaceholder')}
                onChange={(val) => {
                  const inputValue = val.target.value.trim();
                  form.setFieldsValue({ email: inputValue });
                }}
                style={{
                  border: 'none',
                  paddingLeft: 0,
                  borderBottom: '1px solid #E5E5E5',
                  // color: "white",
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  backgroundColor: 'transparent',
                }}
              />
            </Form.Item>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                // backgroundColor: 'pink',
              }}
            >
              <Form.Item style={{ width: '80%' }}>
                {errmessage && (
                  <Alert
                    className="custom-alert"
                    message={errmessage}
                    type="error"
                    style={{
                      marginTop: 16,
                      border: 'none',
                    }}
                  />
                )}
                <Button
                  block
                  type="primary"
                  size="large"
                  htmlType="submit"
                  loading={isLoading}
                  disabled={!isValid}
                  style={{
                    marginTop: 24,
                    fontFamily: 'Roboto500',
                    fontSize: '20px',
                    height: '56px',
                    width: '100%',
                  }}
                >
                  {t('common.submit')}
                </Button>
              </Form.Item>
              {/* <Link
                style={{
                  fontWeight: 'normal',
                  marginLeft: 4,
                  marginRight: 4,
                  color: '#C21B17',
                  textDecoration: 'underline',
                }}
                to="/forgot/login"
                onClick={(e) => e.preventDefault()}
              >
                {t('forgetLoginId.help')}
              </Link> */}
            </div>
          </Form>
        </div>
        <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
      </div>
    </div>
  );
}

export default ForgotPasswordWithEmailPage;
